import axios from 'axios';

axios.defaults.headers.common['Content-Type'] = 'application/json';

const readStorageJson = (key) => {
  try {
    const value = window.localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

const setHeader = (headers, key, value) => {
  if (!value) return;
  if (hasExplicitBlankHeader(headers, key)) return;

  if (typeof headers.set === 'function') {
    headers.set(key, value);
  } else {
    headers[key] = value;
  }
};

const hasExplicitBlankHeader = (headers, key) => {
  if (typeof headers.has === 'function' && headers.has(key)) {
    return headers.get(key) == null;
  }

  return Object.keys(headers).some(
    (headerKey) => headerKey.toLowerCase() === key.toLowerCase() && headers[headerKey] == null
  );
};

axios.interceptors.request.use((config) => {
  // Public referral reads authenticate with the per-application capability.
  if (config.upestateOnboarding) return config;
  const jwtTokens = readStorageJson('jwt-tokens');
  const impersonatedAs = readStorageJson('impersonated-as');

  config.headers = config.headers || {};

  setHeader(config.headers, 'Authorization', jwtTokens?.accessToken);
  setHeader(config.headers, 'IdToken', jwtTokens?.idToken);
  setHeader(config.headers, 'RefreshToken', jwtTokens?.refreshToken);
  setHeader(config.headers, 'ImpersonatedAs', impersonatedAs);

  return config;
});
